import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import moment from "moment";

const ViewModal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">Permits Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <h6 className='text-center d-none'><img src="https://media.istockphoto.com/id/1459824813/vector/health-care-medical-icon-design.jpg?s=612x612&w=0&k=20&c=oJfp94KWM1HJZcykISWWG1W99JiSpeki4gmjIqs44yI=" style={{ width: 100 }} alt="" /></h6>
                    <div class="row g-4">
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Title</span>
                            <p className='word-wrap'>{isEdit?.title || '-'}</p>
                        </div>
                        <div class="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Link:</span>
                            <p className='word-wrap'>
                                {isEdit?.link ? (
                                    <a href={isEdit?.link || void (0)} target="_blank" className="text-primary text-decoration-underline">
                                        {isEdit?.link}
                                    </a>
                                ) : '-'}
                            </p>
                        </div>
                        <div class="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Description:</span>
                            <p className='word-wrap'>
                                {isEdit?.description ?? '-'}
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Created At</span>
                            <p>
                                {isEdit?.created_at ? moment(isEdit?.created_at)?.format('DD-MM-YYYY') : '-'}
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;